export default "__VITE_ASSET__CYS3z9AE__"